<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<h4>{{translate(locale.editAdministrator)}}</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="!loaded">
			<md-card>
				<md-card-content>
					<loading />
				</md-card-content>
			</md-card>
		</div>

		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="loaded">
			<md-card>
				<md-card-content>
					<div class="md-layout">
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
							<div class="md-layout">
								<div class="md-layout-item md-small-size-100 md-size-100 text-right">
									<span class="late">{{translate(locale.required)}}</span>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50">
									<md-field>
										<label>{{translate(locale.userName)}} *</label>
										<md-input type="text" v-model="user.name"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50">
									<md-field>
										<label>{{translate(locale.phoneNumber)}} *</label>
										<md-input type="text" v-model="user.phone_number"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50">
									<md-field>
										<label>{{translate(locale.userUsername)}} *</label>
										<md-input type="text" v-model="user.username" disabled="disabled"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50">
									<md-field>
										<label>{{translate(locale.userRole)}} *</label>
										<md-select :placeholder="translate(locale.userRole) + ' *'" v-model="user.role">
											<md-option value="user">{{translate(locale.roleUser)}}</md-option>
											<md-option value="super-admin">{{translate(locale.roleSuperAdmin)}}</md-option>
										</md-select>
									</md-field>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50">
									<md-field>
										<label>{{translate(locale.password)}} *</label>
										<md-input type="password" v-model="user.password"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50">
									<md-field>
										<label>{{translate(locale.confirmPassword)}} *</label>
										<md-input type="password" v-model="user.confirm_password"></md-input>
									</md-field>
								</div>
							</div>
						</div>
						<div class="md-layout-item md-size-100 text-right">
							<span v-for="e in errors" style="color: red">* {{translate(e)}}<br></span>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
							<md-button class="md-raised md-primary" @click="updateUser()">{{translate(locale.editAdministrator)}}</md-button>
						</div>
					</div>
					
				</md-card-content>
			</md-card>
		</div>
	</div>
		
	</div>

</template>

<script>
	import Editor from '@tinymce/tinymce-vue';
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime, Editor },
		created() {
			this.getUser();
		},

		data() {
			return {
				loaded: false,
				user: {
					name: "",
					phone_number: "",
					username: "",
					password: "",
					confirm_password: "",
					role: ""
				},
				errors: []
			}
		},
		methods: {
			getUser() {
				this.$http.get(this.config.api + "/admin/admin/get/" + this.$route.params.hash).then(data => {
					this.user.name = data.body.data.name;
					this.user.username = data.body.data.username;
					this.user.phone_number = data.body.data.phone_number;
					this.user.role = data.body.data.role;
					this.loaded = true;
				});
			},
			updateUser() {

				if(!this.checkValidation()) {
					this.$notification.notify({message: "Please fill in all required information.||សូមបំពេញព័ត៌មានឱ្យបានគ្រប់គ្រាន់។", icon: 'error', type: 'danger'});
					return;
				}

				this.$http.post(this.config.api + "/admin/admin/update", {
					hash: this.$route.params.hash,
					user: this.user
				}).then(res => {
					if(res.body.status == 'success') {
						this.$notification.notify({
							message: "You have update an account successfully.||អ្នកបានកែប្រែគណនីគ្រប់គ្រងដោយជោគជ័យ។",
							icon: 'check_circle',
							type: 'success'
						});

						this.$router.push("/administrators");
					}
				})
			},
			checkValidation() {
				this.errors = [];

				if(String(this.user.name).length < 3) this.errors.push("Please fill in Name.||សូមបំពេញឈ្មោះ។");
				if(String(this.user.phone_number).length < 3) this.errors.push("Please fill in Phone Number.||សូមបំពេញលេខទូរស័ព្ទ។");
				if(String(this.user.username).length < 3) this.errors.push("Please fill in Login Name.||សូមបំពេញឈ្មោះចូលប្រព័ន្ធ");
				if(String(this.user.role).length <= 0) this.errors.push("Please fill in Role.||សូមបំពេញតួនាទី។");
				if(String(this.user.password).length > 0 && (this.user.password != this.user.confirm_password || this.user.password.length < 8)) this.errors.push("Please fill in Password with more than 8 characters.||សូមបំពេញពាក្យសម្ងាត់លើសពី ៨ តួរអក្សរ។");
				
				if(this.errors.length == 0) return true;
				else return false;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/Administrators/Edit.vue